import React, { useEffect } from 'react';

import { useSearchContext } from '@atlas/core';

import { useSearch } from 'hooks/useSearch';

import { useSearchInputState } from './context/InputProvider';
import EmptyState from './EmptyState';
import SearchError from './Error';
import SearchEvents from './Events';
import Loader from './Loader';
import SearchPrompt from './SearchPrompt';
import SearchResult from './SearchResult';
import SearchTournaments from './Tournaments';

const SearchList = () => {
  const { empty, error, loading, resetSearchResults } = useSearchContext();
  const { focused } = useSearchInputState();
  const { isValidPrompt, searchString } = useSearch();

  useEffect(() => {
    if (isValidPrompt) return;
    resetSearchResults();
  }, [isValidPrompt, resetSearchResults]);

  if (focused && !searchString) return null;
  if (error) return <SearchError />;
  if (!isValidPrompt) return <SearchPrompt />;
  if (loading) return <Loader />;
  if (empty) return <EmptyState />;

  return (
    <>
      <SearchResult />
      <div className="search-list-elements">
        <SearchTournaments />
        <SearchEvents />
      </div>
    </>
  );
};

export default SearchList;
